import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function BusinessValue() {
  const outcomes = ['Serious readers have a useful next step', 'You can see what readers care about', 'Different readers can move toward better-fit offers', 'The book keeps feeding your content, talks, and sales conversations'];
  const contentOutputs = ['Posts', 'Emails', 'Podcast points', 'Workshop prompts', 'Sales follow-up', 'Course lessons', 'Certification ideas', 'Event themes'];
  return <section className="py-24 px-6 max-w-4xl mx-auto border-t border-gray-200 bg-paper-dark relative" data-id="element-35" data-mp="3w3l08wqzojxs">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-36" data-mp="3i8izeo101kru">
        <PathThread data-id="element-37" data-mp="3m89uv51h0p2p" />
      </div>

      <div className="text-center mb-20" data-id="element-38" data-mp="3m9kx30f9porp">
        <Reveal data-id="element-39" data-mp="1gfur409i0757">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-6 leading-tight" data-id="element-40" data-mp="1gfb96jjulir6">
            Your book should keep <br data-id="element-41" data-mp="1kflo4lpmbji6" />
            <span className="italic text-seaglass" data-id="element-42" data-mp="1ke29t0nivij1">working after launch</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 gap-6 mb-32" data-id="element-43" data-mp="30w12k2z3ynp5">
        {outcomes.map((outcome, idx) => <Reveal key={idx} delay={0.1 * idx} data-id="element-44" data-mp="3fknsszq9wzv5" data-mpi={idx}>
            <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-[0_8px_20px_-12px_rgba(26,40,56,0.15)] flex items-start gap-4 hover:-translate-y-1 transition-transform duration-300" data-id="element-45" data-mp="3fjcfo9axufrd">
              <div className="w-8 h-8 rounded-full bg-seaglass/10 text-seaglass flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-46" data-mp="2mwrp3b2ae7ov">
                <div className="w-2.5 h-2.5 rounded-full bg-seaglass" data-id="element-47" data-mp="2hz9pwce2n6u2"></div>
              </div>
              <span className="font-serif text-lg text-navy" data-id="element-48" data-mp="2wrtd23ktt3pv">{outcome}</span>
            </div>
          </Reveal>)}
      </div>

      {/* Content Source Engine Sub-Band */}
      <div className="mb-24" data-id="element-49" data-mp="c2dq5joq9z5i">
        <div className="text-center mb-16" data-id="element-50" data-mp="c5rtov94oeej">
          <Reveal data-id="element-51" data-mp="75ned8jyhppw">
            <h3 className="text-3xl md:text-4xl font-serif text-navy mb-6 leading-tight" data-id="element-52" data-mp="74c89231g5vm">
              The book already gave you <br data-id="element-53" data-mp="e7sfhb3ian83" />
              <span className="italic text-seaglass" data-id="element-54" data-mp="eaes3p597sx6">more to say</span>
            </h3>
          </Reveal>
          <Reveal delay={0.1} data-id="element-55" data-mp="o689pmxtyclt">
            <p className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto" data-id="element-56" data-mp="o5yg7pdktnbd">
              Your book already contains frameworks, stories, questions,
              objections, teaching moments, and reader problems. Those should
              keep feeding:
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.2} data-id="element-57" data-mp="hfa9gi01mmg">
          <div className="mx-auto max-w-3xl" data-id="element-58" data-mp="ejd3udz71z2">
            {/* Desktop: Book IP is the literal center, with eight clear spokes */}
            <div className="relative hidden h-[430px] md:block" data-id="element-59" data-mp="a66zvhzl7uu7">
              <svg className="absolute inset-0 h-full w-full" viewBox="0 0 768 430" aria-hidden="true" data-id="element-60" data-mp="a8jouf3rj5gr">
                
                <g stroke="rgba(139,168,159,0.48)" strokeWidth="1.5" data-id="element-61" data-mp="3dvjzu3usx4ko">
                  <line x1="384" y1="215" x2="112" y2="70" data-id="element-62" data-mp="3dtpi0yettskt" />
                  <line x1="384" y1="215" x2="384" y2="48" data-id="element-63" data-mp="1v0p83xl35dyh" />
                  <line x1="384" y1="215" x2="656" y2="70" data-id="element-64" data-mp="1qyubh6e3nor1" />
                  <line x1="384" y1="215" x2="82" y2="215" data-id="element-65" data-mp="1qzc4zv9dnov9" />
                  <line x1="384" y1="215" x2="686" y2="215" data-id="element-66" data-mp="1lz7vwqastwf2" />
                  <line x1="384" y1="215" x2="112" y2="360" data-id="element-67" data-mp="1m1u1ike4q1un" />
                  <line x1="384" y1="215" x2="384" y2="382" data-id="element-68" data-mp="1gzuzbdu4laza" />
                  <line x1="384" y1="215" x2="656" y2="360" data-id="element-69" data-mp="1c1bdrejg217g" />
                </g>
              </svg>

              <div className="absolute left-1/2 top-1/2 z-10 flex h-40 w-40 -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full border-4 border-seaglass bg-navy px-5 text-center text-paper shadow-[0_22px_46px_-18px_rgba(26,40,56,0.55)]" data-id="element-70" data-mp="17b3c1j00feup">
                <span className="text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-seaglass-light" data-id="element-71" data-mp="y829fsacs5vs">
                  Core asset
                </span>
                <span className="mt-2 font-serif text-2xl font-semibold leading-tight" data-id="element-72" data-mp="oda9wix7n8yd">
                  Book IP
                </span>
              </div>

              {contentOutputs.map((output, idx) => {
              const positions = ['left-0 top-9', 'left-1/2 top-0 -translate-x-1/2', 'right-0 top-9', 'left-0 top-1/2 -translate-y-1/2', 'right-0 top-1/2 -translate-y-1/2', 'bottom-9 left-0', 'bottom-0 left-1/2 -translate-x-1/2', 'bottom-9 right-0'];
              return <div key={output} className={`absolute ${positions[idx]} z-10 rounded-full border border-gray-200 bg-white px-4 py-2.5 text-center text-sm font-medium text-navy shadow-[0_8px_18px_-12px_rgba(26,40,56,0.24)]`} data-id="element-73" data-mp="25n7jvqgysmac" data-mpi={idx}>
                    
                    {output}
                  </div>;
            })}
            </div>

            {/* Mobile: preserve the hub-first relationship without cramped spokes */}
            <div className="flex flex-col items-center md:hidden" data-id="element-74" data-mp="3q4nc5lkujq4h">
              <div className="flex h-36 w-36 flex-col items-center justify-center rounded-full border-4 border-seaglass bg-navy px-4 text-center text-paper shadow-[0_18px_36px_-16px_rgba(26,40,56,0.5)]" data-id="element-75" data-mp="3v2f2ib5uf46k">
                <span className="text-[0.6rem] font-semibold uppercase tracking-[0.18em] text-seaglass-light" data-id="element-76" data-mp="1egii247gi6uf">
                  Core asset
                </span>
                <span className="mt-1.5 font-serif text-xl font-semibold" data-id="element-77" data-mp="1t77v7c4h9w0x">
                  Book IP
                </span>
              </div>
              <div className="h-8 w-px bg-seaglass/50" data-id="element-78" data-mp="225a1o76zdgvl" />
              <div className="grid w-full grid-cols-2 gap-3" data-id="element-79" data-mp="227wasb9is4fx">
                {contentOutputs.map(output => <div key={output} className="rounded-xl border border-gray-200 bg-white px-3 py-3 text-center text-sm font-medium text-navy shadow-sm" data-id="element-80" data-mp="1y3ycg2s0qxnx">
                  
                    {output}
                  </div>)}
              </div>
            </div>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.3} data-id="element-81" data-mp="hs2f96fc60zd">
        <div id="quick-check-4" className="scroll-mt-32" data-id="element-82" data-mp="cr4xguy8n8ye">
          <ReaderPathCheck questionId="q5.authority.shapesCampaigns" checkLabel="Quick Check · 4 of 8" confirmationText="Saved. You're halfway there." data-id="element-83" data-mp="cspselogstws" />
          
        </div>
      </Reveal>
    </section>;
}